export default "__VITE_ASSET__GQwf6CIq__"